import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import MuiModal from "../../../shares/MuiModal";

import EditRingForm from "./EditRingForm";

// import Others files

const EditRing = (props) => {
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-11/12"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <EditRingForm
            openModal={props.openModal}
            setOpenModal={props.setOpenModal}
            getRingsApi={props.getRingsApi}
            item={props.item}
          />
        </div>
      </MuiModal>
    </>
  );
};

export default EditRing;
